import { jwtDecode } from 'jwt-decode';

export const useTokenValidator = () => {
    const isTokenValid = (token) => {
        try {
            const decoded = jwtDecode(token);
            if (!decoded.exp) return { valid: false, decoded: null };

            let exp = decoded.exp;
            // Si exp está en milisegundos, lo convertimos a segundos
            if (exp > 9999999999) {
                exp = exp / 1000;
            }

            const now = Date.now() / 1000; // en segundos
            const valid = exp > now;

            return { valid, decoded };
        } catch (error) {
            return { valid: false, decoded: null };
        }
    };

    return { isTokenValid };
};